import { render, staticRenderFns } from "./PluginReadMoreModal.vue?vue&type=template&id=5e190a05&scoped=true"
import script from "./PluginReadMoreModal.vue?vue&type=script&lang=js"
export * from "./PluginReadMoreModal.vue?vue&type=script&lang=js"
import style0 from "./PluginReadMoreModal.vue?vue&type=style&index=0&id=5e190a05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e190a05",
  null
  
)

export default component.exports